export function Footer() {
    return (
        <div className="container-fluid bg-light text-dark">
            <p className="mx-auto fixed-bottom">
                <span className="text-muted">Quizreo 2022 © LLC  </span>
            </p>
        </div>
    )
}
